import { Component, Input, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PublishingStepStatus } from '@app/features/app-publishing/models/publishing.model';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'rk-step-status-icon',
  imports: [FontAwesomeModule, MatProgressSpinnerModule],
  templateUrl: './step-status-icon.component.html',
  styleUrl: './step-status-icon.component.scss',
})
export class StepStatusIconComponent implements OnInit {
  @Input() status!: PublishingStepStatus;

  ngOnInit() {
    if (!this.status) {
      console.warn('StepStatusIconComponent: Missing required status input');
    }
  }
}
